module.exports = __webpack_public_path__ + "img/swiper_05.d68805b5.jpg";